import { useEffect, useState } from 'react';
import { MODULE } from 'Constants/General';
import { createModule, moduleList, moduleDelete, moduleSingleUpdate, moduleMultiUpdate } from 'Api/EditCoursePage';

const useFetch = ({ courseId }) => {
  const [modules, setModules] = useState([]);
  const [alert, setAlert] = useState('');
  const [currentPositionModule, setCurrentPositionModule] = useState(0);
  const [typeContent, setTypeContent] = useState(MODULE);

  useEffect(() => {
    moduleList({ courseId }).then(fetchedModules => {
      setModules(fetchedModules);
    });
  }, []);

  const deleteModule = async id => {
    await moduleDelete({ id });
    const updatedModules = await moduleList({ courseId });
    setModules(updatedModules);
    setCurrentPositionModule(0);
    setAlert('AlertModuleDeleteSuccess');
  };

  const updateModule = async moduleData => {
    const updatedData = await moduleSingleUpdate({ moduleData });
    const updatedModules = modules.map(module => (module.id === moduleData.id ? updatedData : module));
    setModules(updatedModules);
    setAlert('AlertModuleUpdateSuccess');
  };

  const updateMultipleModules = async moduleData => {
    const currentModule = modules[currentPositionModule];
    let newPosition = 0;
    const newModules = moduleData.map((module, index) => {
      module.order = index + 1;
      const { lessons } = module;
      delete module.lessons;

      if (module.id === currentModule.id) {
        newPosition = index;
      }

      return { ...module, lessons };
    });

    await moduleMultiUpdate({ moduleData });
    setModules(newModules);
    setCurrentPositionModule(newPosition);
  };

  const addModule = () => {
    createModule(courseId).then(newModule => {
      setModules([...modules, newModule]);
      setCurrentPositionModule(modules.length);
    });
  };

  return {
    modules,
    setModules,
    moduleList,
    deleteModule,
    updateModule,
    updateMultipleModules,
    addModule,
    currentPositionModule,
    setCurrentPositionModule,
    typeContent,
    setTypeContent,
    alert,
    setAlert,
  };
};

export default useFetch;
